/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function ensureCarouselFillsHeight(carouselElement: HTMLOcCarouselV1Element): void {
    const carouselShadowRoot = carouselElement.shadowRoot;
    if (!carouselShadowRoot) return;

    const styleElement = document.createElement('style');
    /*                                                                                       */
    /*                                                                                        */
    /*                                                                                         */
    /*                                                                                 */
    styleElement.textContent = `
        :host { display: flex !important; flex-direction: column !important; height: 100% !important; }
        .carousel { flex: 1 1 auto; min-height: 0; }
        .carousel__stage { height: 100%; }
        /**
 *
 *
 */
        .paginationdots { margin-bottom: 15px !important; }
    `;
    carouselShadowRoot.appendChild(styleElement);
}
